<template>
	<DetailsToggle ref="details" title="Nieuwe verantwoordelijke toevoegen">
		<div class="add-form">
			<AlertMessage :problem-detail="responsiblesStore.problemDetail" />
			<ResponsibleForm
					:key="formKey"
					:company-id="companyId"
					:loading="submitting"
					:form-is-required="false"
					@cancel="details?.close()"
					@submit="persistResponsible"
			/>
		</div>
	</DetailsToggle>
</template>
<script setup lang="ts">
	import {computed} from 'vue';
	import {useRoute} from 'vue-router';
	import {ref} from '#imports';
	import {useResponsiblesStore} from '~/store/responsibles/responsibles';
	import DetailsToggle from '~/components/generic/DetailsToggle.vue';
	import ResponsibleForm from '~/components/responsibles/ResponsibleForm.vue';
	import type {ExistingResponsibleCommand, NewResponsibleCommand} from '~/lib/types/responsibleTypes';
	import AlertMessage from '~/components/generic/AlertMessage.vue';

	const route = useRoute();
	const companyId = computed(() => route.params.companyId as string);

	const responsiblesStore = useResponsiblesStore();

	const submitting = ref(false);

	const details = ref<InstanceType<typeof DetailsToggle> | null>(null);

	/**
	 * This key is used to force the form to re-render when a new responsible is added. It is used to reset the form.
	 */
	const formKey = computed(() => responsiblesStore.responsibles.length);

	const persistResponsible = async (entity: ExistingResponsibleCommand | NewResponsibleCommand) => {
		submitting.value = true;
		await responsiblesStore.saveResponsible(companyId.value, entity);
		submitting.value = false;
		details.value?.close();
	};

</script>

<style scoped>
	.add-form {
		background: var(--color-grey-50);
		padding: 20px;
	}
</style>
